import type { TemplateFormsState } from '../index';
import type { LayoutType } from 'types';
import { initialItem } from './addNewSection';

export interface Payload {
  name: string;
  layoutType: LayoutType;
}

export const resetSection = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { name, layoutType } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = sections.findIndex((section) => section.name === name);

  if (sectionIndex === -1) return;

  state[layoutType].sections[sectionIndex] = {
    ...sections[sectionIndex],
    sizeX: 1,
    sizeY: 1,
    subTabs: null,
    items: [{ ...initialItem, subTabId: null }],
  };
};
